<template>
  <div class="project" v-if="project" :key="project.slug">
    <div class="topbar">
      <h1>
        <router-link to="/">{{project.title}}<span v-if="project.year">, </span>{{project.year}}</router-link>
      </h1>
      <router-view name="pager" :project="project"></router-view>
    </div>
    <transition :name="direction" mode="in-out" v-on:after-leave="afterLeave">
      <router-view :key="$route.fullPath" :project="project" :is-animating="isAnimating"></router-view>
    </transition>
  </div>
</template>
<script>
  import Pager from './Pager.vue'
  export default {
    name: 'Project',
    props: {
      project: Object,
      isAnimating: Boolean
    },
    methods: {
      afterLeave () {
        this.$parent.$emit('reset');
      }
    },
    data () {
      return {
        page: {
          url: '1',
        },
        direction:'page-right'
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "../global.scss";

  .project {
    // padding:1rem;
    pointer-events: none;

    .topbar {
      pointer-events: all;

      position:absolute;
      top:0;
      left:0;
      width:calc(100% - 2rem);
      padding:1rem;
      background-color:#fff;
      z-index:1;
      .cross {
        position:absolute;
        right:1rem;
        top:1rem;
      }
    }
    position:absolute;
    top:0;
    left:0;
    width:100%;
    min-height:100vh;
    // background-color:#fff;
    // .blank {
    //   width:100%;
    //   height:100vh;
    //   position:fixed;
    //   top:0;
    //   left:0;
    //   background-color:#fff;
    //   z-index:100;
    // }
  }


  .left-leave,
  .right-leave {
    &:after {
      transition: background-color 0.7s ease;
      content:'';
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.1);
      z-index: 2;
    }
  }

  .left-leave-active,
  .right-leave-active {
    transition: background-color 0.7s ease;
    &:after {
      transition: background-color 0.7s ease;
      content:'';
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.1);
      z-index: 2;
    }
  }
  .left-leave-to,
  .right-leave-to {
    background-color: #000;
    &:after {
      background-color: rgba(0,0,0,0.3);
    }
  }
  .right-enter,
  .left-enter {
    .pager,
    h1 {
      opacity: 0;
    }
  }
  .left-enter-active,
  .right-enter-active {
    opacity: 1;
    // transition: all 0.7s cubic-bezier(0.000, 0.000, 0.215, 0.990);
    transition: all 0.7s cubic-bezier(.15,.81,.77,1);
    z-index: 2;
    .pager,
    h1 {
      transition: opacity 0.4s ease-in;
      transition-delay: 0.2s;
    }
  }
  .left-enter-to,
  .right-enter-to {
    .pager,
    h1 {
      opacity: 1;
    }
    transform: translate3d(0vw,0,0);
  }
  .right-enter {
    transform: translate3d(100vw,0,0);
  }
  .left-enter {
    transform: translate3d(-100vw,0,0);
  }
</style>



// WEBPACK FOOTER //
// src/components/Project.vue